import { Component, OnInit, Input, inject, signal } from '@angular/core';
//import { NgFor } from '@angular/common';
//import { ThemeDirective } from '../../../directives/theme.directive';
import { IBrandInfo } from '../../../interfaces/brand/brand-info';
import { TextResourceService } from '../../../services/session/text-resource.service';
import { TxtResPipe } from '../../../pipes/txt-res.pipe';
// import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-brand-header-with-locale',
    standalone: true,
    imports: [
        //ThemeDirective,
        TxtResPipe,
        //NgFor
    ],
    templateUrl: './brand-header-with-locale.component.html',
    styleUrl: './brand-header-with-locale.component.css',
})
export class BrandHeaderWithLocaleComponent  implements OnInit {

  @Input() data: any;

  // readonly translateService = inject(TranslateService);
  readonly textResourceService = inject(TextResourceService);

  brandName!: string;
  headerText!: string;
  brandLogoImage!: any;
  isBrandLogoImageShown: boolean = false;
  isHeaderTextShown: boolean = false;

  // title: string = 'Basil';
  // subtitle: string = 'Basil';
  isEnglish: boolean = true;
  textResources: Map<string,string> = new Map<string, string>();

  constructor() {
    // this.translateService.addLangs(['en', 'es']);
    // this.translateService.setDefaultLang('en');

    // Get User Language from Browser
    // const browserLang = this.translateService.getBrowserLang() || 'en';
    // this.translateService.use(browserLang.match(/en|es/) ? browserLang : 'en');

    // this.textResourceService.addLangs(['en', 'es']);
    // this.textResourceService.setDefaultLang('en');


  }

  ngOnInit(): void {
    this.makeBrandHeader(this.data);
    this.textResources.set('title', 'Keep your pass handy');
    this.textResources.set('subtitle', 'Add your pass to your mobile wallet');
  }

  makeBrandHeader (brandInfo: IBrandInfo) {
    // Display the brand name
    this.brandName = brandInfo.brandName;
    if (brandInfo.sectionText) {
      this.headerText = brandInfo.sectionText;
      this.isHeaderTextShown = true;
    }
    // Display the brand logo image, if possible
    this.brandLogoImage = null;
    this.isBrandLogoImageShown = false;
    if (brandInfo.imageDescr) {
      this.brandLogoImage = 'data:' + brandInfo.imageDescr.imageType + ';base64,' + brandInfo.imageDescr.imageContent;
      this.isBrandLogoImageShown = true;
    }
  }

  switchLanguage(language: string) {
    // this.translateService.use(language);
    this.textResources.clear();
    if (this.isEnglish) {
      this.textResourceService.setCurrentLang('es');
      this.textResources.set('title', 'Parece que no estás');
      this.textResources.set('subtitle', 'Escanea el siguiente código con tu iPhone para renderizar tu pase');
    } else {
      this.textResourceService.setCurrentLang('en');
      this.textResources.set('title', 'Keep your pass handy');
      this.textResources.set('subtitle', 'Add your pass to your mobile wallet');
    }

  }

}
